<template>
  <div id="accordionFlushExample" class="faqs-accordion">
    <div v-for="(faq, index) in faqs" :key="index" class="faq-item translate">
      <div :id="'flush-heading' + index" class="faq-header">
        <button
          class="faq-button"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="'#flush-collapse' + index"
          :aria-expanded="fromPdf || index === 0"
          :aria-controls="'flush-collapse' + index">
          <div class="d-flex align-items-center faq-button-content">
            <span class="faq-number h6 p-m text-landing align-self-start">{{
              String(index + 1).padStart(2, '0')
            }}</span>
            <span class="semibold h6 p-m text-landing faq-question">{{ faq.pregunta }}</span>
          </div>
          <span class="faq-chevron text-landing">
            <CustomIcon :icon="desplegarIcon" size="16px" class="faq-chevron-icon faq-chevron-down" />
            <CustomIcon :icon="plegarIcon" size="16px" class="faq-chevron-icon faq-chevron-up" />
          </span>
        </button>
      </div>
      <div
        :id="'flush-collapse' + index"
        :class="['accordion-collapse collapse', { show: fromPdf || index === 0 }]"
        :aria-labelledby="'flush-heading' + index"
        data-bs-parent="#accordionFlushExample">
        <div class="d-flex align-items-start faq-body">
          <span class="faq-number h6 p-m text-landing">&nbsp;</span>
          <WysiwygVisualizer :content="faq.respuesta" class="faq-answer translate text-landing" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import WysiwygVisualizer from '@/components/common/WysiwygVisualizer.vue';
  import CustomIcon from '@/components/CustomIcon.vue';
  import plegarIcon from '@/assets/icons/raw/plegar.svg';
  import desplegarIcon from '@/assets/icons/raw/desplegar.svg';

  defineProps({
    faqs: {
      type: Array,
      default: () => [],
    },
    fromPdf: {
      type: Boolean,
      default: false,
    },
  });
</script>

<style lang="scss" scoped>
  .faqs-accordion {
    width: 100%;
  }

  .faq-item {
    border-top: 1px solid var(--landing-text-color) !important;
    width: 100%;
  }

  .faq-header {
    width: 100%;
  }

  .faq-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 30px 10px;
    background: transparent;
    border: none;
    text-align: left;
    cursor: pointer;
    transition: all 0.3s ease;

    @media (max-width: 768px) {
      gap: 8px;
    }

    &[aria-expanded='true'] {
      .faq-chevron-down {
        display: none;
      }

      .faq-chevron-up {
        display: block;
      }
    }

    @media (max-width: 768px) {
      padding: 20px 7px;
    }
  }

  .faq-number {
    flex-shrink: 0;
    font-weight: 400;
    min-width: 22px;

    @media (max-width: 768px) {
      min-width: 17px;
    }
  }

  .faq-button-content {
    flex: 1;
    min-width: 0;
    gap: 20px;

    @media (max-width: 768px) {
      gap: 12px;
    }
  }

  .faq-question {
    min-width: 0;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }

  .faq-chevron {
    flex-shrink: 0;
  }

  .faq-chevron-up {
    display: none;
  }

  .faq-body {
    padding: 0 10px 20px 10px;
    min-width: 0;
    gap: 20px;

    @media (max-width: 768px) {
      padding: 0 7px 12px 7px;
      gap: 12px;
    }
  }

  .faq-answer {
    flex: 1;
    min-width: 0;
    overflow-wrap: break-word;
    word-wrap: break-word;

    :deep(a) {
      word-break: break-word;
    }
  }
</style>
